import {
  RESUME_SESSION_SUCCESS,
  REGISTER_SUCCESS,
  LOGIN_SUCCESS,
  LOGOUT_SUCCESS,
  AuthState,
} from './types';

export const initState: AuthState = {
  authenticated: false,
};

export const authReducer = (state = initState, action: any): AuthState => {
  switch (action.type) {
    case RESUME_SESSION_SUCCESS:
    case REGISTER_SUCCESS:
    case LOGIN_SUCCESS: {
      const { accessToken, referralCode, user, hubspotToken } = action;
      return { authenticated: true, accessToken, referralCode, user, hubspotToken };
    }
    case LOGOUT_SUCCESS: {
      return initState;
    }
    default:
      return state;
  }
};

export default authReducer;
